import { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  selectedTemplateFiltersState,
  selectedSpherical as selectedSphericalState,
  selectedAssemblyId as selectedAssemblyIdState,
} from '@/components/Analysis/state';

export const useResetSelectedFilters = () => {
  const setSelectedTemplateFilters = useSetAtom(selectedTemplateFiltersState);
  const selectedSpherical = useAtomValue(selectedSphericalState);
  const selectedAssemblyId = useAtomValue(selectedAssemblyIdState);

  useEffect(() => {
    if (selectedSpherical && selectedAssemblyId) {
      setSelectedTemplateFilters(() => {
        return [];
      });
    }
  }, [selectedAssemblyId, selectedSpherical, setSelectedTemplateFilters]);
};
